<template>
  <div class="dialogBoxMessages">
    <div class="notificationTitle">
      <BaseIcon
        name="infoSM"
        class="dialogAlertIcon"
        width="1em"
        height="1em"
      />
      <span class="dialogTitleText">
        {{ messageDetails.type }}
      </span>
    </div>
    <span class="dialogNotificationMessageText">
      {{ messageDetails.message }}
    </span>
  </div>
</template>
<script>
import { formatDate } from '@/utils/time/formatDate';
import { mapState } from 'vuex';

export default {
  name: 'NotificationMessages',
  props: {
    messageDetails: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('globalState/settings', ['timezoneoffset']),
    getFormattedStartTime() {
      return formatDate(
        this.messageDetails.startTime,
        this.timezoneoffset,
        'MMM DD, YYYY [at] hh:mm A',
      );
    },
    getFormattedEndTime() {
      return formatDate(
        this.messageDetails.endTime,
        this.timezoneoffset,
        'MMM DD, YYYY [at] hh:mm A',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.notificationTitle {
  @include flex-center-justify(flex-start);
}
.dialogTitleText {
  font-size: 0.775rem;
  font-weight: bolder;
  color: $color-white;
}
.dialogBoxMessages {
  width: 22rem;
  height: 4.5rem;
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  border-radius: 0.5rem;
  background-color: #1d1d1d;
  overflow-y: auto;
}
.dialogNotificationMessageText {
  width: 20.938rem;
  margin-left: 0.438rem;
  font-size: 0.8rem;
  line-height: normal;
  text-align: left;
  color: #cecece;
  display: flex;
}

.dialogAlertIcon {
  padding-right: 0.35rem;
  padding-left: 0.625rem;
}
</style>
